import {
  GET_PRODUCTTYPE,
  GET_PRODUCTTYPE_FAIL,
  GET_PRODUCTTYPE_SUCCESS,
  GET_PRODUCTTYPES,
  GET_PRODUCTTYPES_FAIL,
  GET_PRODUCTTYPES_SUCCESS,
  ADD_NEW_PRODUCTTYPE,
  ADD_PRODUCTTYPE_SUCCESS,
  ADD_PRODUCTTYPE_FAIL,
  UPDATE_PRODUCTTYPE,
  UPDATE_PRODUCTTYPE_SUCCESS,
  UPDATE_PRODUCTTYPE_FAIL,
  DELETE_PRODUCTTYPE,
  DELETE_PRODUCTTYPE_SUCCESS,
  DELETE_PRODUCTTYPE_FAIL,
  SET_STATE_PRODUCTTYPE,
  UPDATE_PRODUCTTYPE_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_PRODUCTTYPE,
  payload: loading,
})

export const getProductTypes = ( params ) => ({
  type: GET_PRODUCTTYPES,
  payload: { params },
})

export const getProductTypesSuccess = (productTypes, totalPages, currentPage) => ({
  type: GET_PRODUCTTYPES_SUCCESS,
  payload: {productTypes:productTypes, total:totalPages, currentPage:currentPage }
})

export const getProductTypesFail = error => ({
  type: GET_PRODUCTTYPES_FAIL,
  payload: error,
})

export const addNewProductType = productType => ({
  type: ADD_NEW_PRODUCTTYPE,
  payload: productType,
})

export const addProductTypeSuccess = productType => ({
  type: ADD_PRODUCTTYPE_SUCCESS,
  payload: productType,
})  

export const addProductTypeFail = error => ({
  type: ADD_PRODUCTTYPE_FAIL,
  payload: error,
})

export const updateProductType = productType => ({
  type: UPDATE_PRODUCTTYPE,
  payload: productType,
})

export const updateProductTypeStatus = productType => ({
  type: UPDATE_PRODUCTTYPE_STATUS,
  payload: productType,
})

export const updateProductTypeSuccess = productType => ({
  type: UPDATE_PRODUCTTYPE_SUCCESS,
  payload: productType,
})

export const updateProductTypeFail = error => ({
  type: UPDATE_PRODUCTTYPE_FAIL,
  payload: error,
})

export const deleteProductType = productType => ({
  type: DELETE_PRODUCTTYPE,
  payload: productType,
})

export const deleteProductTypeSuccess = id => ({
  type: DELETE_PRODUCTTYPE_SUCCESS,
  id,
})

export const deleteProductTypeFail = error => ({
  type: DELETE_PRODUCTTYPE_FAIL,
  payload: error,
})

export const getProductType = () => ({
  type: GET_PRODUCTTYPE,
})

export const getProductTypeSuccess = productType => ({
  type: GET_PRODUCTTYPE_SUCCESS,
  payload: productType,
})

export const getProductTypeFail = error => ({
  type: GET_PRODUCTTYPE_FAIL,
  payload: error,
})
